<div class="viewer-toolbar" mat-dialog-title>
  <span class="viewer-filename" [title]="data.originalFileName">{{ data.originalFileName }}</span>

  @if (isImage && !loading && !error) {
  <div class="image-controls">
    <button mat-icon-button matTooltip="Zoom out" (click)="zoomOut()" [disabled]="imageZoom <= 0.25">
      <mat-icon>remove</mat-icon>
    </button>
    <span class="zoom-label">{{ (imageZoom * 100).toFixed(0) }}%</span>
    <button mat-icon-button matTooltip="Zoom in" (click)="zoomIn()" [disabled]="imageZoom >= 5">
      <mat-icon>add</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Reset zoom" (click)="resetZoom()">
      <mat-icon>center_focus_strong</mat-icon>
    </button>
  </div>
  }

  <button mat-icon-button matTooltip="Close" (click)="dialogRef.close()" class="close-btn">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="viewer-content">

  @if (loading) {
  <div class="state-container">
    <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
    <p>Loading file…</p>
  </div>
  }

  @else if (error) {
  <div class="state-container">
    <mat-icon color="warn" style="font-size: 48px; height: 48px; width: 48px;">error_outline</mat-icon>
    <p>Unable to load file. The link may have expired.</p>
  </div>
  }

  @else if (isPdf) {
  <ngx-extended-pdf-viewer
    [src]="fileUrl"
    [height]="'78vh'"
    [showToolbar]="true"
    [showFindButton]="true"
    [showPagingButtons]="true"
    [showZoomButtons]="true"
    [showPresentationModeButton]="true"
    [showOpenFileButton]="false"
    [showPrintButton]="true"
    [showDownloadButton]="true"
    [showSecondaryToolbarButton]="false">
  </ngx-extended-pdf-viewer>
  }

  @else if (isImage) {
  <div class="image-viewport">
    <img
      [src]="fileUrl"
      [alt]="data.originalFileName"
      [style.transform]="'scale(' + imageZoom + ')'"
      class="preview-image" />
  </div>
  }

  @else if (isVideo) {
  <div class="media-container">
    <video [src]="fileUrl" controls class="media-player">
      Your browser does not support video playback.
    </video>
  </div>
  }

  @else if (isAudio) {
  <div class="media-container">
    <mat-icon style="font-size: 64px; height: 64px; width: 64px; color: #ff9800;">audio_file</mat-icon>
    <p>{{ data.originalFileName }}</p>
    <audio [src]="fileUrl" controls class="audio-player">
      Your browser does not support audio playback.
    </audio>
  </div>
  }

  @else {
  <div class="state-container">
    <mat-icon style="font-size: 64px; height: 64px; width: 64px; color: #757575;">insert_drive_file</mat-icon>
    <p>Preview is not available for this file type.</p>
    <a [href]="fileUrl" target="_blank" mat-stroked-button color="primary">Open in browser</a>
  </div>
  }

</mat-dialog-content>
